import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

const eventMarkerStyles = `
    .event-marker-icon > div {
        width: 40px; height: 40px;
        background: linear-gradient(135deg, #2E7D32 0%, #1B5E20 100%);
        border: 3px solid white; border-radius: 50%;
        display: flex; align-items: center; justify-content: center;
        box-shadow: 0 3px 8px rgba(46, 125, 50, 0.6);
        cursor: pointer; transition: transform 0.2s ease;
    }
    @keyframes event-marker-pulse {
        0%, 100% { transform: scale(1); box-shadow: 0 3px 8px rgba(46, 125, 50, 0.6); }
        50% { transform: scale(1.15); box-shadow: 0 3px 12px rgba(46, 125, 50, 0.9); }
    }
    @keyframes event-marker-bounce {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-5px); }
    }
    .event-marker-icon.event-marker-hover > div { animation: event-marker-pulse 0.6s ease-in-out infinite; }
    .event-marker-icon.event-marker-active > div { animation: event-marker-bounce 1s ease-in-out infinite; }
    .share-menu {
        position: fixed; background: white; border-radius: 12px;
        box-shadow: 0 4px 20px rgba(0,0,0,0.2); padding: 8px; z-index: 10000; min-width: 200px;
    }
    .share-menu-item {
        display: flex; align-items: center; gap: 12px; padding: 12px 16px;
        cursor: pointer; border-radius: 8px; transition: background 0.2s;
        text-decoration: none; color: #333; font-size: 14px;
    }
    .share-menu-item:hover { background: #f5f5f5; }
    .share-menu-item svg { width: 24px; height: 24px; }
`;

const eventMarkerTooltipStyles = `
    .event-marker-tooltip {
        background: transparent !important; border: none !important;
        box-shadow: none !important; font-size: 20px; margin: 0; padding: 0; line-height: 1;
    }
    .event-marker-tooltip::before { display: none !important; }
`;

if (typeof document !== 'undefined' && !document.getElementById('event-marker-tooltip-styles')) {
    const s = document.createElement('style'); s.id = 'event-marker-tooltip-styles'; s.textContent = eventMarkerTooltipStyles; document.head.appendChild(s);
}
if (typeof document !== 'undefined' && !document.getElementById('event-marker-styles')) {
    const s = document.createElement('style'); s.id = 'event-marker-styles'; s.textContent = eventMarkerStyles; document.head.appendChild(s);
}

if (typeof window !== 'undefined') {
    window._eventRegistry = window._eventRegistry || {};
}

if (typeof window !== 'undefined') {
    window.shareEvent = function (eventName, lat, lng, regionName, contentType) {
        const type = contentType === 'trekkings' ? 'trekkings' : 'experiences';
        const apiBase = process.env.REACT_APP_API_URL_NODE || '';
        const socialLink = `${apiBase}/share?r=${encodeURIComponent(regionName)}&t=${type}&poi=${lat},${lng}&zoom=17&name=${encodeURIComponent(eventName)}&event=1`;
        const directLink = `${window.location.origin}/region/${encodeURIComponent(regionName)}/${type}?poi=${lat},${lng}&zoom=17&name=${encodeURIComponent(eventName)}&event=1`;
        const onlyLink = `${window.location.origin}/region/${encodeURIComponent(regionName)}/${type}?poi=${lat},${lng}&zoom=17&event=1`;
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        const canNativeShare = isMobile && !!navigator.share;

        const existingMenu = document.getElementById('share-menu');
        if (existingMenu) { existingMenu.remove(); return; }

        const menu = document.createElement('div');
        menu.id = 'share-menu';
        menu.className = 'share-menu';
        menu.style.cssText = `position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); background: white; border-radius: 12px; box-shadow: 0 4px 20px rgba(0,0,0,0.3); padding: 12px; z-index: 10000; min-width: 250px;`;
        menu.dataset.eventName = eventName;
        menu.dataset.deepLink = socialLink;
        menu.dataset.directLink = directLink;
        menu.dataset.onlyLink = onlyLink;

        menu.innerHTML = `
            <div style="padding: 8px 12px; border-bottom: 1px solid #eee; font-weight: bold; margin-bottom: 8px;">Condividi evento</div>
            ${canNativeShare ? `<div class="share-menu-item" onclick="window.shareTo('native')"><svg viewBox="0 0 24 24" fill="#666" width="24" height="24"><path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.02-4.11c.53.5 1.23.81 2.07.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.06 9.81C7.53 9.31 6.83 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.83 0 1.53-.31 2.06-.81l7.12 4.16c-.05.2-.08.41-.08.63 0 1.52 1.23 2.75 2.75 2.75S21 23.52 21 22s-1.23-2.75-2.75-2.75z"/></svg><span>Condividi… (menu smartphone)</span></div>` : ''}
            <div class="share-menu-item" onclick="window.shareTo('whatsapp')"><svg viewBox="0 0 24 24" fill="#25D366" width="24" height="24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg><span>WhatsApp</span></div>
            <div class="share-menu-item" onclick="window.shareTo('threads')"><svg viewBox="0 0 24 24" fill="#000000" width="24" height="24"><path d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.59 12c.025 3.086.718 5.496 2.057 7.164 1.432 1.783 3.631 2.698 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.14 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.96-.065-1.187.408-2.285 1.33-3.09.88-.77 2.082-1.225 3.474-1.313 1.03-.065 1.985.028 2.856.275-.096-.997-.467-1.762-1.104-2.28-.716-.58-1.746-.878-3.06-.886h-.04c-1.058.007-1.958.286-2.603.807l-1.3-1.56c.974-.81 2.262-1.236 3.862-1.267h.053c1.735.013 3.11.456 4.085 1.317.92.814 1.476 1.95 1.66 3.39.59.14 1.132.33 1.62.578 1.474.747 2.503 1.87 2.973 3.243.723 2.108.387 4.674-1.452 6.472C18.269 23.19 15.696 23.978 12.186 24zm-1.065-8.89c-.078 0-.158.002-.238.006-.906.057-1.607.34-2.03.82-.396.447-.567.998-.512 1.637.1 1.14 1.15 1.886 2.674 1.804 1.09-.06 1.94-.473 2.528-1.205.478-.595.795-1.418.945-2.452-.744-.25-1.56-.398-2.443-.449-.316-.02-.63-.04-.924-.04v-.12z"/></svg><span>Threads</span></div>
            <div class="share-menu-item" onclick="window.shareTo('email')"><svg viewBox="0 0 24 24" fill="#EA4335" width="24" height="24"><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg><span>Email</span></div>
            <div class="share-menu-item" onclick="window.shareTo('copy')"><svg viewBox="0 0 24 24" fill="#666" width="24" height="24"><path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/></svg><span>Copia link</span></div>
            <div class="share-menu-item" onclick="window.shareTo('copyFacebook')"><svg viewBox="0 0 24 24" fill="#666" width="24" height="24"><path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/></svg><span>Copia link per Facebook</span></div>
            <div class="share-menu-item" onclick="window.shareTo('onlyLink')"><svg viewBox="0 0 24 24" fill="#666" width="24" height="24"><path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/></svg><span>Copia link per WhatsApp/Instagram</span></div>
        `;

        document.body.appendChild(menu);
        setTimeout(() => {
            document.addEventListener('click', function closeMenu(e) {
                if (!menu.contains(e.target)) { menu.remove(); document.removeEventListener('click', closeMenu); }
            });
        }, 100);
    };

    window.shareTo = function (platform) {
        const menu = document.getElementById('share-menu');
        if (!menu) return;
        const eventName = menu.dataset.eventName;
        const deepLink = menu.dataset.deepLink;
        const directLink = menu.dataset.directLink;
        const onlyLink = menu.dataset.onlyLink;
        const text = `${eventName}\n${deepLink}`;

        switch (platform) {
            case 'whatsapp': window.open(`https://wa.me/?text=${encodeURIComponent(eventName + '\n' + deepLink)}`, '_blank'); break;
            case 'threads': window.open(`https://www.threads.net/intent/post?text=${encodeURIComponent(text)}`, '_blank'); break;
            case 'email': window.location.href = `mailto:?subject=${encodeURIComponent(eventName + ' - AI Hiking')}&body=${encodeURIComponent(text)}`; break;
            case 'copy':
                navigator.clipboard.writeText(`${eventName}\n${directLink}`).then(() => {
                    const item = menu.querySelector(`[onclick*="shareTo('copy')"]`);
                    if (item) { const span = item.querySelector('span'); if (span) span.textContent = '✅ Copiato!'; setTimeout(() => menu.remove(), 1500); }
                }); return;
            case 'copyFacebook':
                navigator.clipboard.writeText(`${eventName}\n${deepLink}`).then(() => {
                    const item = menu.querySelector(`[onclick*="shareTo('copyFacebook')"]`);
                    if (item) { const span = item.querySelector('span'); if (span) span.textContent = '✅ Copiato!'; setTimeout(() => menu.remove(), 1500); }
                }); return;
            case 'onlyLink':
                navigator.clipboard.writeText(`${onlyLink}`).then(() => {
                    const item = menu.querySelector(`[onclick*="shareTo('onlyLink')"]`);
                    if (item) { const span = item.querySelector('span'); if (span) span.textContent = '✅ Copiato!'; setTimeout(() => menu.remove(), 1500); }
                }); return;
            case 'native':
                navigator.share({ title: eventName, text: eventName, url: onlyLink }).catch(() => { }); return;
        }
        menu.remove();
    };
}

// Offset per distanziare il marker evento dal marker POI (solo per Point/activity)
const ACTIVITY_OFFSET_LAT = 0.0003; // ~33m verso nord
const ACTIVITY_OFFSET_LON = 0.0003; // ~25m verso est

export default function EventMarkers({ features, events, nameRegion, contentType }) {
    const map = useMap();

    useEffect(() => {
        if (!features || !map || !events || events.length === 0) return;

        const params = new URLSearchParams(window.location.search);
        const shouldOpenEventFromUrl = params.get('event') === '1' && !!params.get('poi');
        let targetLat = null, targetLon = null, targetZoom = 17;

        if (shouldOpenEventFromUrl) {
            const [a, b] = String(params.get('poi')).split(',').map(Number);
            if (!Number.isNaN(a) && !Number.isNaN(b)) { targetLat = a; targetLon = b; }
            const z = Number(params.get('zoom'));
            if (!Number.isNaN(z) && z > 0) targetZoom = z;
        }

        const markers = [];
        const markersWithCoords = [];
        const processedTrails = new Set();

        // Pulisci registry ad ogni render
        window._eventRegistry = {};
        window._weatherCoords = {};

        features.forEach((feature) => {
            const props = feature.properties || feature.poi?.properties || {};
            const geometryType = feature.geometry?.type || feature.poi?.geometry?.type;
            const trailId = feature.id || props.id || feature.poi?.id;

            if (!trailId || processedTrails.has(trailId)) return;
            if (geometryType !== 'LineString' && geometryType !== 'MultiLineString' && geometryType !== 'Point') return;

            const trailEvents = events.filter(e => {
                const eventTrailId = e.trailId || e.trail?.id || e.poi?.id;
                return eventTrailId === trailId;
            });
            if (trailEvents.length === 0) return;
            processedTrails.add(trailId);

            let startCoords = null;
            if (geometryType === 'LineString') startCoords = feature.geometry.coordinates?.[0];
            else if (geometryType === 'MultiLineString') startCoords = feature.geometry.coordinates?.[0]?.[0];
            else if (geometryType === 'Point') startCoords = feature.geometry?.coordinates || feature.poi?.geometry?.coordinates;
            if (!startCoords || startCoords.length < 2) return;

            // Coordinate originali del POI/trail (usate per meteo, share, URL)
            const lat = Number(startCoords[1]);
            const lon = Number(startCoords[0]);
            if (isNaN(lat) || isNaN(lon)) return;

            // Salva coords originali nel registry per meteo
            window._weatherCoords[trailId] = {
                lat,
                lon,
                name: props.name || trailEvents[0]?.eventName || 'Percorso'
            };

            // Coordinate del marker: offset solo per Point (activity/POI) per evitare sovrapposizione
            const isPoint = geometryType === 'Point';
            const markerLat = isPoint ? lat + ACTIVITY_OFFSET_LAT : lat;
            const markerLon = isPoint ? lon + ACTIVITY_OFFSET_LON : lon;

            try {
                const marker = L.circleMarker([markerLat, markerLon], {
                    radius: 18, fillColor: '#2E7D32', color: 'white', weight: 3,
                    opacity: 1, fillOpacity: 1, className: 'event-circle-marker'
                }).bindTooltip('🥾👥', {
                    permanent: true, direction: 'center',
                    className: 'event-marker-tooltip', offset: [0, 0]
                });

                marker.addTo(map);

                marker.on('mouseover', function () { const i = this._icon; if (i) i.classList.add('event-marker-hover'); });
                marker.on('mouseout', function () { const i = this._icon; if (i) i.classList.remove('event-marker-hover'); });
                marker.on('popupopen', function () { const i = this._icon; if (i) i.classList.add('event-marker-active'); });
                marker.on('popupclose', function () { const i = this._icon; if (i) i.classList.remove('event-marker-active'); });

                const eventsHTML = trailEvents.map(event => {
                    const eventId = event._id || event.id || `evt_${Date.now()}_${Math.random().toString(36).substr(2, 5)}`;
                    window._eventRegistry[eventId] = event;

                    const eventDate = new Date(event.eventDate).toLocaleDateString('it-IT', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
                    const eventType = event.eventType === 'activity' ? '✨' : '🥾👥';

                    return `<div 
                        style="padding: 12px; background: #E8F5E9; border-radius: 6px; border-left: 4px solid #2E7D32; margin: 8px 0; cursor: pointer; transition: all 0.2s;"
                        onclick="window.openEventDetail('${eventId}');"
                        onmouseover="this.style.background='#C8E6C9'; this.style.transform='translateX(4px)';"
                        onmouseout="this.style.background='#E8F5E9'; this.style.transform='translateX(0)';"
                        title="Clicca per vedere i dettagli"
                    >
                        <div style="display: flex; justify-content: space-between; align-items: center;">
                            <strong style="color: #1B5E20; font-size: 15px;">${eventType} ${event.eventName}</strong>
                            <span style="color: #4CAF50; font-size: 16px;">›</span>
                        </div>
                        <span style="color: #666; font-size: 13px;">📅 ${eventDate}</span>
                        ${event.organizerName ? `<br/><span style="color: #666; font-size: 12px;">👤 ${event.organizerName}</span>` : ''}
                        ${event.difficulty ? `<br/><span style="color: #666; font-size: 12px;">⚡ ${event.difficulty}</span>` : ''}
                    </div>`;
                }).join('');

                const safeTrailName = (props.name || 'Percorso').replace(/'/g, "\\'").replace(/"/g, '\\"');
                const safeEventName = (trailEvents[0].eventName || safeTrailName).replace(/'/g, "\\'").replace(/"/g, '\\"');

                const popupContent = `
                    <div style="min-width: 280px; max-width: min(400px, 90vw); max-height: 80vh; overflow-y: auto; font-size: 14px;">
                        <strong style="font-size: 16px;">${props.name || 'Percorso'}</strong><br/>
                        <div style="margin: 12px 0; padding: 8px; background: linear-gradient(135deg, #2E7D32 0%, #1B5E20 100%); color: white; border-radius: 6px; text-align: center; font-weight: bold;">
                            🥾👥 ${trailEvents.length} Evento/i in programma
                        </div>
                        <div style="font-size: 12px; color: #888; text-align: center; margin-bottom: 4px;">👆 Clicca su un evento per i dettagli</div>
                        ${eventsHTML}
                        <div style="margin-top: 12px; display: grid; grid-template-columns: 1fr 1fr; gap: 8px;">
                            ${trailEvents.some(e => e.eventType === 'trail_buddy') ? `
                            <button style="flex: 1; padding: 8px 12px; background: #4CAF50; color: white; border: none; border-radius: 4px; font-size: 13px; cursor: pointer;"
                                onclick="window.viewRouteDetail('${trailId}');">🗺️ Vedi percorso</button>
                            ` : ''}
                            <button style="padding: 8px 12px; background: #2196F3; color: white; border: none; border-radius: 4px; font-size: 13px; cursor: pointer;"
                                onclick="window.openWeatherById('${trailId}');">🌤️ Meteo</button>
                            <button style="padding: 8px 12px; background: #FF9800; color: white; border: none; border-radius: 4px; font-size: 13px; cursor: pointer; display: flex; align-items: center; gap: 6px; justify-content: center;"
                                onclick="window.shareEvent('${safeEventName}', ${lat}, ${lon}, '${nameRegion}', '${contentType}');">
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M12 22s7-6.5 7-12a7 7 0 1 0-14 0c0 5.5 7 12 7 12z" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                Condividi</button>
                        </div>
                    </div>`;

                marker.bindPopup(popupContent, { maxWidth: 400, className: 'custom-popup' });
                markers.push(marker);
                // markersWithCoords usa le coords ORIGINALI per il match da URL
                markersWithCoords.push({ marker, lat, lon });
            } catch (error) {
                console.error('❌ Errore creazione marker evento:', error);
            }
        });

        if (shouldOpenEventFromUrl && targetLat != null && targetLon != null && markersWithCoords.length > 0) {
            let best = null, bestDist = Infinity;
            for (const m of markersWithCoords) {
                const d = map.distance([targetLat, targetLon], [m.lat, m.lon]);
                if (d < bestDist) { bestDist = d; best = m; }
            }
            // Soglia 200m per coprire anche l'offset applicato al marker
            if (best && bestDist < 200) {
                map.closePopup();
                map.setView([targetLat, targetLon], targetZoom, { animate: false });
                setTimeout(() => { try { best.marker.openPopup(); } catch (e) { } }, 50);
            }
        }

        return () => {
            markers.forEach((m) => { try { map.removeLayer(m); } catch (e) { } });
        };
    }, [features, map, events, nameRegion, contentType]);

    return null;
}
